export default "__VITE_ASSET__FVT8Qwm3__"